"use client";

import { createContext } from "react";

export const TabContext = createContext({
  activeKey: null,
  onSelect: () => {},
});
